import { applyEmptyChartState, seriesHasData } from '@/data/chartEmptyState.js'

const IGNORE_LIST = ['/run', '/dev/shm', '/tmp', '/boot', '/sys', '/var/tmp']

function shouldIgnore(label) {
  return IGNORE_LIST.some((prefix) => label.startsWith(prefix))
}

export function getChartOptions(seriesMap) {
  const options = {
    animation: false,
    title: {
      text: '',
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
        label: {
          backgroundColor: '#6a7985',
        },
      },
    },
    legend: {
      orient: 'horizontal',
      bottom: '4%',
    },
    grid: {
      top: '3%',
      left: '3%',
      right: '4%',
      bottom: '15%',
      containLabel: true,
    },
    toolbox: {
      show: false,
      feature: {
        restore: {},
      },
    },
    xAxis: {
      type: 'time',
      boundaryGap: false,
    },
    yAxis: {
      type: 'value',
      min: 0,
      max: 100,
      axisLabel: {
        formatter(value) {
          return `${value} %`
        },
      },
    },
    series: [],
  }

  Object.keys(seriesMap).forEach((label) => {
    if (shouldIgnore(label)) {
      return
    }

    options.series.push({
      id: label,
      name: label,
      type: 'line',
      smooth: true,
      showSymbol: false,
      areaStyle: {
        opacity: 0.1,
      },
      lineStyle: {
        width: 1,
      },
      data: seriesMap[label],
    })
  })

  return applyEmptyChartState(options, seriesHasData(options.series))
}
